import { trans } from "@mongez/localization";

export function MapLegend() {
  return (
    <div className="absolute bottom-4 right-4 flex flex-col items-start gap-2 rounded-lg bg-black/20 px-3 py-2 backdrop-blur-sm sm:bottom-6 sm:right-6 sm:flex-row sm:items-center sm:gap-4 sm:px-4 sm:py-3 lg:bottom-11 lg:right-20 lg:gap-6">
      {legendItems.map((item, index) => (
        <div key={index} className="flex items-center gap-2 sm:gap-3 lg:gap-4">
          <div className={`size-3 rounded-full sm:size-[14px] ${item.color}`}></div>
          <span className="text-xs text-white sm:text-sm">{trans(item.label)}</span>
        </div>
      ))}
    </div>
  );
}

const legendItems = [
  {
    color: "bg-white",
    label: "senaatOffices",
  },
  {
    color: "bg-bright-orange",
    label: "salesCoverage",
  },
];
